import React from 'react'
import C1BenefitsHead from './C1BenefitsHead'
import C1BenefitsMain from './C1BenefitsMain'

const C1Benefits = () => {
  return (
    <div className='lvlBenefitsContainer'>
    <C1BenefitsHead/>
    <C1BenefitsMain/>
  </div>
  )
}

export default C1Benefits
